import React, { Component, Suspense } from 'react';
import HeaderComponent from './../components/HeaderComponent';
import FooterComponent from '../components/FooterComponent';
import TopMainComponent from '../components/TopMainComponent';
import BottomMainComponent from '../components/BottomMainComponent';
import { inject, observer } from 'mobx-react';
import LeftMenuComponent from './../components/LeftMenuComponent';
import RightMenuComponent from './../components/RightMenuComponent';
import ToastGeneratorComponent from '../components/BaseComponent/ToastGeneratorComponent';
import { isIOS } from 'react-device-detect';
import PopUpModalComponent from '../components/BaseComponent/PopUpModalComponent';
import ProcessingBetItemComponent from '../components/BaseComponent/ProcessingBetItemComponent';
import logErrorTracker from '../common/decorator/logErrorTracker';
import loadLanguageOnPage from '../common/decorator/loadLanguageOnPage';
import Constants from '../common/Constants';
import LoadingBar from '../components/BaseComponent/LoadingComponent';
import TemplateServices from "../services/TemplateServices";
import CommonActions from '../actions/CommonActions';
import Utils from '../common/Utils';
import { BROWSER_KEY, MARKET_STRATEGIES } from '../common/Foundation';
import StorageHelper from '../common/StorageHelper';
import MbInputOtpComponent from '../components/HeaderComponent/MbInputOtpComponent';

const DoubleSidebar = CommonActions.lazyWithPreload(() => import( "../components/BaseComponent/SideBarComponent/doubleSidebar"));
const ScrollTopButton = CommonActions.lazyWithPreload(() => import('../components/BaseComponent/ScrollTopComponent'));
const AsiaDoubleSidebar = CommonActions.lazyWithPreload(() => import('../components/BaseComponent/SideBarComponent/asiaDoubleSidebar'));
const MbAsiaScrollTopComponent = CommonActions.lazyWithPreload(() => import('../components/BaseComponent/MbAsiaScrollTopComponent'));
const MbNewBetSlip = CommonActions.lazyWithPreload(() => import('../components/BetslipComponent/NewBetslipAsianView'));

@logErrorTracker()
@loadLanguageOnPage()
@inject('LayoutTemplateStore', 'SportsStore', 'AccountStore', 'SportsMenuStore', 'EsportsLiveStore')
@observer
class MbLayoutPage extends Component {
    constructor(props) {
        super(props);
        this.currentWidth = window.innerWidth;
        this.LayoutTemplateStore = this.props.LayoutTemplateStore;
        this.themeDefaultB2BArcadia = Utils.themeDefaultB2BArcadia();
    }

    componentDidMount() {
        window.addEventListener("resize", this.resize);
        this.resize();
        document.getElementsByTagName('html')[0].dataset.theme = this.themeDefaultB2BArcadia;
    }

    

    componentWillUnmount() {
        window.removeEventListener("resize", this.resize);
    }

    buildAfrQuery() {
		const afTtId = Utils.getParameterByName("ttid") || '';
        const paramAfCode = Utils.getParameterByName("a") || '';
		const query = `?a=${paramAfCode}&ttid=${afTtId}`;
        const afrcCode = StorageHelper.getBrowsersStorage(BROWSER_KEY.AFRC);
		if(paramAfCode && window.env.marketStrategies === MARKET_STRATEGIES.CASH) {
            TemplateServices.getClickLogAPI(query);
            if (!afrcCode) {
                StorageHelper.saveBrowsersStorage(BROWSER_KEY.AFRC, paramAfCode, { expires: window.env.afrcExpriseTime });
            }
            this.props.AccountStore.updateAffiliateCode(paramAfCode);
            this.props.history.push(`/${Utils.getUserLanguage()}/${Utils.getViewPathByURLPath()}/`);
		}
	}

    resize = () => {
        //ipad pro landscape or desktop
        if (this.currentWidth != window.innerWidth) {
            this.currentWidth = window.innerWidth;
            if (window.innerWidth >= 1268) {
                if (this.LayoutTemplateStore.currentViewContainer === 'euroView') {
                    this.props.LayoutTemplateStore.updateAlwaysShowSideBar(true, true);
                }

            } else
                //ipad portrait
                if (window.innerWidth >= 720 && this.LayoutTemplateStore.currentViewContainer === 'euroView') {
                    this.props.LayoutTemplateStore.updateAlwaysShowSideBar(true, false);
                }
                else {
                    this.props.LayoutTemplateStore.updateAlwaysShowSideBar(false, false);
                }
        }
    }

    onSetClose = () => {
        let {
            docked,
            open
        } = this.props.LayoutTemplateStore.sidebarProps;
        if (docked || open) {
            this.LayoutTemplateStore.closeSideBar();
        }
    }

    renderMainComponents = () => {
        return <React.Fragment>
                    <HeaderComponent className="HeaderComponent" />
                    <TopMainComponent className="TopMainComponent" />
                    {this.props.children}
                    <FooterComponent className="FooterComponent" />
                    {!isIOS ? <ScrollTopButton /> : ""}
                </React.Fragment>
    }

    renderSidebar = (sidebarProps) => {
        const { currentViewContainer, currentPageContainer, reloadInternal } = this.LayoutTemplateStore;

        if (currentViewContainer === 'asiaView') {
          const router = {
            match: this.props.match,
            history: this.props.history,
            location: this.props.location,
          }
          const isSideBarOpened = sidebarProps.docked || sidebarProps.open 
          const styles =
          currentPageContainer === Constants.PAGE_NAME.ODDS_PAGE_CONTAINER
              ? {
                  root: { overflow: isSideBarOpened ? "hidden" : "visible" },
                  headerStyle: { position: isIOS ? "-webkit-sticky" : "sticky", zIndex: 6 },
                  topMainStyle: { position: isIOS ? "-webkit-sticky" : "sticky" },
                  betSlipStyle: { zIndex: 7 },
                  sidebar: { transition: "opacity 0.5s ease-in-out" },
                }
              : { 
                  topMainStyle: { zIndex: 5 },
                  headerStyle: { zIndex: 6 },
                };
            
          return (
            <React.Fragment>
              <AsiaDoubleSidebar
                rootClassName={(currentPageContainer) ? currentPageContainer + " " : "" + currentViewContainer} sidebar={this.ref}
                sidebarLeft={<LeftMenuComponent className="LeftMenuComponent" />}
                sidebarRight={<RightMenuComponent className={this.themeDefaultB2BArcadia + " RightMenuComponent"}/>}  {...sidebarProps}
                header={<HeaderComponent className="HeaderComponent" router={router}/>}
                topMain={this.props.EsportsLiveStore.matchupData.stickyTabBars 
                  ? null 
                  : <TopMainComponent className="TopMainComponent" />}
                bottomMain={<BottomMainComponent className="BottomMainComponent" />}
                footer={currentPageContainer !== 'promotionsPageContainer' && currentPageContainer !== 'promotionSurveyContainer' && <FooterComponent className="FooterComponent"/>}
                betslip={<MbNewBetSlip className="BetslipComponent"/>}
                styles={styles}
              >
                {this.props.children}
              </AsiaDoubleSidebar>
              {currentPageContainer !== 'homePageContainer' && <MbAsiaScrollTopComponent />}
            </React.Fragment>
          );
        }
        return <DoubleSidebar rootClassName={currentPageContainer ? currentPageContainer + " " : "" + currentViewContainer} 
                     sidebar={this.ref} sidebarLeft={<LeftMenuComponent className="LeftMenuComponent" />}
                    sidebarRight={<RightMenuComponent className="RightMenuComponent" />}  {...sidebarProps} >
                    <LoadingBar view={currentViewContainer} className="pageLoading" percent={100}></LoadingBar>
                    {this.renderMainComponents()}
                </DoubleSidebar>
    }

    render() {
        let sidebarWidth = Constants.EURO_VIEW_SIDEBAR_WITHD;
        let { docked, open, pullRight, alwaysShowLeft, alwaysShowRight } = this.props.LayoutTemplateStore.sidebarProps;
        let sidebarProps = {
            sidebarClassName: this.themeDefaultB2BArcadia + " menu-bar",
            contentId: "menu-content",
            docked, open, pullRight,
            onSetClose: this.onSetClose,
            alwaysShowLeft: alwaysShowLeft,
            alwaysShowRight: alwaysShowRight,
            leftSidebarWidth: sidebarWidth,
            rightSidebarWidth: sidebarWidth
        };

        // resize the side bar width with the width of screen
        if (this.LayoutTemplateStore.currentViewContainer === 'asiaView') {
            if (document.documentElement.clientWidth >= 375) {
                sidebarProps.leftSidebarWidth = Constants.ASIA_VIEW_SIDEBAR_WIDTH_LEFT;
            } else if (document.documentElement.clientWidth >= 360) {
                sidebarProps.leftSidebarWidth = Constants.MID_ASIA_VIEW_SIDEBAR_WIDTH_LEFT;
            }
            else {
                sidebarProps.leftSidebarWidth = Constants.SMALL_ASIA_VIEW_SIDEBAR_WIDTH_LEFT;
            }
            sidebarProps.rightSidebarWidth = Constants.ASIA_VIEW_SIDEBAR_WIDTH_RIGHT;
        }

        return (<React.Fragment>
                    <Suspense fallback={CommonActions.renderWaitLoading(null)}>
                        {this.renderSidebar(sidebarProps)}
                    </Suspense>

                    <PopUpModalComponent />
                    <MbInputOtpComponent/>
                    <ProcessingBetItemComponent />
                    <ToastGeneratorComponent />
                </React.Fragment>
                );
    }
}

export default MbLayoutPage;


// WEBPACK FOOTER //
// ./src/app/pages/MbLayoutPage.js